import axios from 'axios'
const resource = '/attendance'

export default {}
